module.exports = __webpack_public_path__ + "static/img/khzc.47658fab.png";